import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom'
import { verifyInvitation } from '../../redux/invited-staff/actions/invitedStaff.actions';
import { AppDispatch } from '../../redux/rootReducer';
import Loader from '../../components/common/loader/Loader';
import Toast from '../../components/common/toast/Toast';
import toast from 'react-hot-toast';
import PineappleJuice from '../../images/pineapple-juice.svg';
import styles from './StaffInvitation.module.css';
import { noPermissionsAssigned } from '../../redux/setInitialPermission/actions/setInitialPermission.action';

const StaffInvitation = () => {

    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    const loggedUserEmail = localStorage.getItem('email')
    let invitedEmail = searchParams.get("email");
    if (invitedEmail) {
        invitedEmail = invitedEmail.trim().replace(/ /g, '+');
    }
    const invitedLocationId = searchParams.get("locationId");
    const invitedAdminId = searchParams.get("adminId");
    const invitedStaffCode = searchParams.get('staffCode');
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState('');
    const [toastMessage, setToastMessage] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [response, setResponse] = useState<number | null>(null);

    const onSuccess = (message: string, statusCode: number) => {
        setToastMessage(message);
        setToastType('success');
        setShowToast(true);
        setShowLoader(false);
        setResponse(statusCode)
    }

    const onFailure = (message: string, statusCode: number) => {
        setShowLoader(false)
        if (message === '404') {
            localStorage.clear();
            toast.error('Account is not created.')
            navigate(`/signup${location.search}`);
        } else {
            setToastMessage(message);
            setToastType('error');
            setShowToast(true);
            setResponse(statusCode)
        }
    }


    useEffect(() => {
        if (showToast) {
            setTimeout(() => {
                setShowToast(false);
                setToastType('')
            }, 4000);
        }
    }, [showToast])


    const verifyStaffInvitation = () => {
        if (invitedEmail?.toLowerCase() === loggedUserEmail?.toLowerCase()) {
            const obj = {
                locationId: invitedLocationId,
                email: invitedEmail,
                adminId: invitedAdminId,
                staffCode: invitedStaffCode
            }
            setShowLoader(true);
            dispatch(verifyInvitation(obj, onSuccess, onFailure));
        } else {
            setResponse(201);
        }
    }

    useEffect(() => {
        if (!!invitedEmail && !!loggedUserEmail) {
            verifyStaffInvitation()
        }

    }, [invitedEmail, loggedUserEmail]);


    const handleLogout = () => {
        localStorage.clear();
        dispatch(noPermissionsAssigned());
        navigate(`/${location?.search}`, { replace: true });
    };

    return (
        <div className='outletConainer'>
            {showLoader &&
                <Loader />
            }
            {showToast && <Toast type={toastType} message={toastMessage} />}
            {!!response && <div className={styles.invitationPageContainer}>
                {response !== 201 && <div className={styles.invitationInfo}>
                    <img className={styles.pineappleJuice} src={PineappleJuice} alt="Check" width={132} height={260} />
                    <p className={styles.invitationMessage}>{toastMessage}</p>
                    <a className={styles.btnGreen} href='/locations'>View properties</a>
                </div>
                }
                {
                    response === 201 && <div className={styles.invitationInfo}>
                        <img className={styles.pineappleJuice} src={PineappleJuice} alt="Check" width={132} height={260} />
                        <p className={styles.invitationMessage}>{`You're currently logged in with a different account. Please log in using ${invitedEmail}.`}</p>
                        <button className={styles.btnGreen} onClick={handleLogout}>Back to login</button>
                    </div>
                }
            </div>
            }
        </div >
    )
}

export default StaffInvitation
